export * from './quickpay_payment_list.component';